import type { IComponent, IThemeComponent } from '../hooks/types/components';

const isThemeComponent = (component: IComponent): component is IThemeComponent => component?.key === 'theme';

export default function migrateProperties<
  T extends EngineAPI.IGenericHyperCubeProperties & { components?: IComponent[] },
>(properties: T): T {
  const themeComponent = properties.components?.find(isThemeComponent);
  const image = themeComponent?.background?.image;
  // Legacy documents may still hold the invalid 'auto' background image sizing value; normalize it to 'originalSize'.
  if (image && (image.sizing as string) === 'auto') {
    image.sizing = 'originalSize';
  }
  return properties;
}
